class Position {
    x: number;
    y: number;
    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }
}

enum HouseType {
    PLUS = 3, STAR, MINUS
}

class House {
    type: HouseType;
    size: number
    base: Position
    positions: Position[]
    vector: Position
    housePos: Position


    constructor(type: HouseType, base: Position, vector: Position, rotation: boolean) {
        this.type = type;
        this.base = base;
        this.vector = vector;
        this.size = (type === HouseType.PLUS || type === HouseType.MINUS) ? 3 : 4;
        this.positions = [base];
        for (let i = 1; i < this.size; i++) {
            if (type === HouseType.PLUS) {
                let vector2 = new Position(Math.abs(vector.x), Math.abs(vector.y));
                if (isEgal(vector2, new Position(1, 1))) {
                    this.vector = new Position(this.vector.x, 0);
                }
                this.positions[i] = new Position(this.positions[i-1].x - this.vector.x, this.positions[i-1].y - this.vector.y);
            } else if (type === HouseType.MINUS) {
                if (i === 1) {
                    this.positions[i] = new Position(this.base.x, this.base.y + this.vector.y);
                } else {
                    this.positions[i] = new Position(this.base.x - this.vector.x, this.base.y);
                }
            } else {
                this.vector = (!isEgal(this.vector, new Position(-1, -1))) ? new Position(Math.abs(this.vector.x), Math.abs(this.vector.y)) : this.vector;
                if (i === 1) {
                    this.positions[i] = new Position((!rotation) ? this.base.x - this.vector.x : this.base.x, (!rotation) ? this.base.y : this.base.y - this.vector.x);
                } else if (i === 2) {
                    this.positions[i] = new Position((!rotation) ? this.base.x + this.vector.x : this.base.x, (!rotation) ? this.base.y : this.base.y + this.vector.x);
                } else {
                    this.positions[i] = new Position((!rotation) ? this.positions[i-1].x : this.base.x - this.vector.y, (!rotation) ? this.base.y + this.vector.y : this.positions[i-1].y);
                }
            }
        }
        if (type === HouseType.PLUS) {
            this.housePos = this.positions[1];
        } else if (type === HouseType.MINUS) {
            this.housePos = this.positions[0];
        } else {
            this.housePos = this.positions[2];
        }
    }

    public toString(): string {
        let str = `${this.type}:[`;
        for (let i = 0; i < this.size; i++) {
            str += `${this.positions[i].x},${this.positions[i].y}${(i === this.size - 1) ? "];;" : ";"}`;
        }
        return str;
    }
}

class Matrice {
    rows: number
    cols: number
    data: number[][]

    constructor(rows: number, cols: number) {
        this.rows = rows;
        this.cols = cols;
        this.data = [];
        for (let i = 0; i < rows; i++) {
            this.data[i] = [];
            for (let j = 0; j < cols; j++) {
                this.data[i][j] = 0;
            }
        }
    }
}

class PigGame {
    grid: Matrice
    pigs: Position[]
    wolf: Position
    houses: House[] = [undefined, undefined, undefined]
    needHide: boolean


    constructor(pigs: Position[], wolf: Position) {
        this.grid = new Matrice(4, 4);
        for (let i = 0; i < 4; i++) {
            for (let j = 0; j < 4; j++) {
                let val = ((i === 0 && j === 0) || (i === 3 && j === 0) || (i === 0 && j === 3)) ? -1 : 0;
                let pos = new Position(i, j);
                for (let k = 0; k < 3; k++) {
                    if (isEgal(pigs[k], pos)) {
                        val = 1;
                        break;
                    }
                }
                if (isEgal(wolf, pos)) {
                    val = 2;
                }
                this.grid.data[i][j] = val;
            }
        }
        this.pigs = pigs;
        this.wolf = wolf;
        this.needHide = this.wolf !== undefined;
    }

    public addHouse(house: House) {
        if (!this.canHouseFit(house)) {
            return;
        }
        for (let i = 0; i < house.size; i++) {
            this.grid.data[house.positions[i].x][house.positions[i].y] = house.type;
        }
        this.houses[house.type - 3] = house;
    }

    public removeHouse(house: House) {
        for (let i = 0; i < house.size; i++) {
            let pos = house.positions[i];
            let val = 0
            for (let j = 0; j < 3; j++) {
                if (isEgal(this.pigs[j], pos)) {
                    val = 1;
                    break;
                }
            }
            if (isEgal(this.wolf, pos)) {
                val = 2;
            }
            this.grid.data[pos.x][pos.y] = val;
        }
        this.houses[house.type - 3] = undefined;
    }

    public canHouseFit(house: House): boolean {
        for (let i = 0; i < house.size; i++) {
            let pos = house.positions[i];
            if (pos.x < 0 || pos.x >= 4 || pos.y < 0 || pos.y >= 4)  return false;
            if (this.grid.data[pos.x][pos.y] !== 0) {
                if (this.grid.data[pos.x][pos.y] === 1 && this.needHide) {
                    continue
                }
                return false;
            }
        }
        return true;
    }

    public isValid(): boolean {
        for (let i = 0; i < 3; i++) {
            let isValid = false
            let pos = this.pigs[i];
            if (pos === undefined || (isNaN(pos.x) && isNaN(pos.y))) {
                continue;
            }
            if (this.needHide) {
                for (let j = 0; j < 3; j++) {
                    let house = this.houses[j].housePos;
                    if (isEgal(pos, house)) {
                        isValid = true;
                        break;
                    }
                }
            } else {
                if (this.grid.data[pos.x][pos.y] === 1) {
                    isValid = true;
                }
            }
            if (!isValid) {
                return false;
            }
        }
        if (this.needHide) {
            if (this.grid.data[this.wolf.x][this.wolf.y] !== 2) {
                return false;
            }
        }
        return true;
    }

    public getAvailablePosition(): Position[] {
        let positions: Position[] = [];
        for (let i = 0; i < this.grid.rows; i++) {
            for (let j = 0; j < this.grid.cols; j++) {
                if (this.grid.data[i][j] === 0 || (this.grid.data[i][j] === 1 && this.needHide)) {
                    positions.push(new Position(i, j));
                }
            }
        }
        return positions;
    }

    public fillWithHouse(): boolean {
        return this.fillWithHouseIndex(HouseType.PLUS);
    }

    public fillWithHouseIndex(type: HouseType): boolean {
        let availablePositions = this.getAvailablePosition();
        for (let i = 0; i < availablePositions.length; i++) {
            let pos = availablePositions[i];
            let nmbRotation = (type === HouseType.STAR) ? 2 : 1;
            for (let j = 0; j < nmbRotation; j++) {
                for (let k = 0; k < 4; k++) {
                    let vector: Position
                    if (type === HouseType.PLUS) {
                        vector = new Position((k % 2 === 0) ? (k < 2) ? -1 : 1 : 0, (k % 2 !== 0) ? (k < 2) ? -1 : 1 : 0);
                    } else {
                        vector = new Position((k < 2) ? 1 : -1, (k % 2 === 0) ? 1 : -1)
                    }
                    let house = new House(type, pos, vector, (j === 1));
                    if (this.canHouseFit(house)) {
                        this.addHouse(house);
                        if (type === HouseType.MINUS) {
                            if (this.isValid()) {
                                return true;
                            }
                            this.removeHouse(house);
                            if (i-1 === availablePositions.length) {
                                return false;
                            }
                            continue
                        }
                        let next: boolean = this.fillWithHouseIndex(type + 1);
                        if (next) {
                            return true;
                        }
                        this.removeHouse(house);
                    }
                }
            }
        }
        return false;
    }
}

function isEgal(a: Position, b: Position): boolean {
    if (a === undefined || b === undefined) return false;
    return a.x === b.x && a.y === b.y;
}

module.exports = {Position, HouseType, House, Matrice, PigGame};